import { CustomizedDxColumn } from '../generateColumns';

export function calculateFilterExpression(
	this: CustomizedDxColumn,
	filterValue: string,
	selectedFilterOperation: string
) {
	return [[`${this.dataField}.text`, selectedFilterOperation || 'contains', filterValue]];
}

export function calculateFilterExpressionDynamic(
	this: CustomizedDxColumn,
	filterValue: string,
	selectedFilterOperation: string
) {
	return [`${this.dataField}`, selectedFilterOperation || 'contains', filterValue];
}

export const filterOperations = ['contains', 'notcontains', 'startswith', 'endswith', '=', '<>'];
